import CheckIdDatosMaestrosScreen from "@/components/checkid/CheckIdDatosMaestrosScreen";

/** Alias legacy /laboral/validar-inscribir — misma pantalla Check ID. */
export default function LaboralValidarInscribir() {
  return <CheckIdDatosMaestrosScreen testId="laboral-validar-inscribir-page" />;
}
